export const WORKSPACE_SWITCHER_LAYOUT = Object.freeze({
  HEADER_HEIGHT: 52, // py-2.5 (20px) + size-8 avatar (32px)
  SETTINGS_SECTION_HEIGHT: 72,
  SEARCH_INPUT_HEIGHT: 40, // CommandInput compact
  ACCOUNT_ITEM_HEIGHT: 36,
  ADD_WORKSPACE_HEIGHT: 44, // p-1 (8px) + menu item (~36px)
  USER_SECTION_HEIGHT: 56,
  SIGN_OUT_HEIGHT: 44, // p-1 (8px) + menu item (~36px)
  SEPARATORS: 2, // 2 separators at 1px each
  EMPTY_LIST_HEIGHT: 72,
  MAX_VISIBLE_ACCOUNTS: 6,
  MAX_POPOVER_HEIGHT_DESKTOP: 480,
  MAX_POPOVER_HEIGHT_MOBILE: 420,
} as const);
export function getWorkspaceSwitcherChromeHeight(): number {
  const {
    HEADER_HEIGHT,
    SETTINGS_SECTION_HEIGHT,
    SEARCH_INPUT_HEIGHT,
    ADD_WORKSPACE_HEIGHT,
    USER_SECTION_HEIGHT,
    SIGN_OUT_HEIGHT,
    SEPARATORS,
  } = WORKSPACE_SWITCHER_LAYOUT;

  return (
    HEADER_HEIGHT +
    SETTINGS_SECTION_HEIGHT +
    SEARCH_INPUT_HEIGHT +
    ADD_WORKSPACE_HEIGHT +
    USER_SECTION_HEIGHT +
    SIGN_OUT_HEIGHT +
    SEPARATORS
  );
}

export function getWorkspaceSwitcherListHeight(accountCount: number): number {
  const { ACCOUNT_ITEM_HEIGHT, EMPTY_LIST_HEIGHT, MAX_VISIBLE_ACCOUNTS } =
    WORKSPACE_SWITCHER_LAYOUT;

  if (accountCount === 0) {
    return EMPTY_LIST_HEIGHT;
  }

  return Math.min(accountCount, MAX_VISIBLE_ACCOUNTS) * ACCOUNT_ITEM_HEIGHT;
}

export function getWorkspaceSwitcherPopoverHeight({
  accountCount,
  isMobile,
}: {
  accountCount: number;
  isMobile: boolean;
}): number {
  const maxPopoverHeight = isMobile
    ? WORKSPACE_SWITCHER_LAYOUT.MAX_POPOVER_HEIGHT_MOBILE
    : WORKSPACE_SWITCHER_LAYOUT.MAX_POPOVER_HEIGHT_DESKTOP;

  return Math.min(
    maxPopoverHeight,
    getWorkspaceSwitcherChromeHeight() + getWorkspaceSwitcherListHeight(accountCount)
  );
}
